import styled from 'styled-components';

export const Container = styled.div`
  & .ant-radio-inner:after {
    all: initial;
  }
`;
